import MemorableSection from './MemorableSection';
export default MemorableSection;
